export default __webpack_public_path__ + "static/media/hsc-logo.214b9e00.png";